import React, { useState } from 'react';
import classNames from 'classnames';
import DownChevron from 'assests/icons/down-chevron.icon';

import './mobile-tab-bar.less';

const MobileTabBar = ({ props, item: Item }) => {
  const [opened, setOpened] = useState(false);
  return (
    <div className={classNames('mobile-tab-wrapper', { active: opened })}>
      <div
        className="mobile-tab--active"
        onClick={() => {
          setOpened(!opened);
        }}
      >
        <div className="arrow">
          <DownChevron />
        </div>
        {
          props.panes.filter((item, index) => {
            return props.activeKey == item.key;
          })[0].props.tab
        }
      </div>
      {opened && (
        <Item {...props}>
          {(node) => {
            return (
              <div
                className="mobile-tab-wrapper__item"
                onClick={(e) => {
                  setOpened(false);
                }}
              >
                {node}
              </div>
            );
          }}
        </Item>
      )}
    </div>
  );
};

export default MobileTabBar;
